<script lang="ts">
  // libs
  import * as _ from "lodash";
  import { onMount } from "svelte";

  // component
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import SelectFilter from "@shared/svelte/Components/SelectFilter.svelte";
  import DatePicker from "@shared/svelte/Components/DatePicker.svelte";
  import PaginationLarge from "@shared/svelte/Components/Pagination/Large.svelte";
  import Table from "@distributor/svelte/Payments/Table.svelte";

  // services
  import * as PaymentsService from "@distributor/svelte/Services/payments_service";

  // stores
  import { reset, PaymentsStore } from "@distributor/svelte/Stores/PaymentsStore";

  // data
  const statuses = [
    { id: null, label: "All Statuses", value: null },
    { id: 1, label: "Pending", value: "pending" },
    { id: 2, label: "Settled", value: "succeeded" },
    { id: 3, label: "Failed", value: "failed" },
    { id: 4, label: "Canceled", value: "canceled" },
  ];

  const fetchTransfers = async (page?: number) => {
    // reset table
    reset();

    // fetch
    await PaymentsService.index(
      $PaymentsStore.transfers,
      $PaymentsStore.filters,
      Number(page || 1)
    );
  };

  // lifecycle
  onMount(function () {
    let i = document.getElementById("distributor-payment-search-input");
    if (i) i.focus();
    (async () => {
      await fetchTransfers();
    })();
  });

  // reactives
  $: hasTransfers = $PaymentsStore.transfers.length > 0;
  $: pagination = {
    ...$PaymentsStore.pagination,
    goToPage: nextPageNum => fetchTransfers(nextPageNum),
  };

</script>

<FizzStyles>
  <div data-testid="payments-index" class="fizz-surface">
    <div class="fizz-flex-row-responsive fizz-inset-square-32">
      <input
        type="text"
        name="search"
        id="distributor-payment-search-input"
        data-testid="distributor-payment-search-input"
        placeholder="Search Account Name, Invoice Number, Order Number, or Confirmation Code"
        class="fizz-input-search fizz-full-width fizz-text-strong responsive-input"
        bind:value={$PaymentsStore.filters.searchValue}
        on:keyup={_ => fetchTransfers()}
      />
      <SelectFilter
        fontColor={"#262626"}
        selectId={"distributor-payment-status-filter"}
        options={statuses}
        onChange={fetchTransfers}
        bind:selectedValue={$PaymentsStore.filters.status}
      />
      <DatePicker
        bind:startDate={$PaymentsStore.filters.startDate}
        bind:endDate={$PaymentsStore.filters.endDate}
        defaultButtonLabel={"All Transaction Dates"}
        minWidth={"275px"}
        selectButtonStyle={false}
        runFilters={fetchTransfers}
      />
    </div>

    <Table />

    {#if hasTransfers}
      <div class="fizz-stack-12">
        <PaginationLarge {pagination} />
      </div>
    {/if}
  </div>
</FizzStyles>
